import { InjectionToken } from '@angular/core';

export interface RuntimeConfig {
  keycloakUrl: string;
  realm: string;
  clientId: string;
  notificationApiUrl: string;
  auditApiUrl: string;
  backendApiUrl: string;
  supportEmail: string;
  supportPhone: string;
}

export const RUNTIME_CONFIG = new InjectionToken<RuntimeConfig>(
  'runtime config',
);

export function validateRuntimeConfig(
  value: unknown,
  origin: string,
): RuntimeConfig {
  if (!value || typeof value !== 'object')
    throw new Error('Не задана конфигурация приложения');
  const config = value as RuntimeConfig;
  for (const key of [
    'keycloakUrl',
    'notificationApiUrl',
    'auditApiUrl',
    'backendApiUrl',
  ] as const) {
    if (typeof config[key] !== 'string' || !config[key])
      throw new Error(`Не задан ${key}`);
    const url = new URL(config[key], origin);
    if (
      !['http:', 'https:'].includes(url.protocol) ||
      url.username ||
      url.password ||
      url.search ||
      url.hash
    ) {
      throw new Error(`Некорректный ${key}`);
    }
  }
  for (const key of ['realm', 'clientId'] as const) {
    if (typeof config[key] !== 'string' || !config[key].trim())
      throw new Error(`Не задан ${key}`);
  }
  return {
    ...config,
    supportEmail: config.supportEmail ?? '',
    supportPhone: config.supportPhone ?? '',
  };
}

export function isApiRequest(
  requestUrl: string,
  apiBases: string[],
  origin: string,
): boolean {
  const url = new URL(requestUrl, origin);
  return apiBases.some((base) => {
    const allowed = new URL(base, origin);
    const prefix = allowed.pathname.replace(/\/$/, '');
    return (
      url.origin === allowed.origin &&
      (url.pathname === prefix || url.pathname.startsWith(`${prefix}/`))
    );
  });
}

export function localReturnPath(value: unknown, origin: string): string | null {
  if (
    typeof value !== 'string' ||
    !value.startsWith('/') ||
    value.startsWith('//')
  )
    return null;
  try {
    const url = new URL(value, origin);
    if (
      url.origin !== origin ||
      [
        '/auth',
        '/auth-code',
        '/administration-required',
        '/no-access',
        '/page-not-found',
      ].includes(url.pathname)
    )
      return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}
